// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  UPLOAD_FILE_STORE: `${env.baseApiUrl}/scrooge/store/file`,
  UPLOAD_MULTI_FILE_STORE: `${env.baseApiUrl}/scrooge/store/files`,
  GET_FILE_STORE: `${env.baseApiUrl}/scrooge/file/:fileId?v=-1`,
  GET_FILE_INFORMATION: `${env.baseApiUrl}/scrooge/file/:fileId/info`,
  MAKE_EPHEMERAL_FILES: `${env.baseApiUrl}/scrooge/file/ephemeralize`,
});

export const uploadFileStoreApi = postCreator(endpoints.UPLOAD_FILE_STORE);
export const uploadMultiFileStoreApi = postCreator(
  endpoints.UPLOAD_MULTI_FILE_STORE
);

export const uploadImageStoreApi = (formData: FormData, options?: any) => {
  const enhancedFormData = new FormData();

  const hasMultipleFiles = Array.from(formData.keys()).some(key =>
    key.includes('files')
  );

  for (const [key, value] of formData.entries()) {
    enhancedFormData.append(key, value);
  }

  enhancedFormData.append('resourceType', 'IMAGE');

  return hasMultipleFiles
    ? uploadMultiFileStoreApi(enhancedFormData, options)
    : uploadFileStoreApi(enhancedFormData, options);
};

export const getImageStoreApi = getCreator(endpoints.GET_FILE_STORE);

export const getFileInformationApi = getCreator(endpoints.GET_FILE_INFORMATION);

export const makeEphemeralFilesApi = postCreator(
  endpoints.MAKE_EPHEMERAL_FILES
);
